var gvUrl=window.gvUrl||(window.gvUrl=function(p){var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';return r+String(p).replace(/^\//,'')});
var gvTr=window.gvTr||(window.gvTr=function(k,f){var d=window.GV_I18N;return d&&d[k]!=null?d[k]:f});
/**
 * Main Product Form Controller
 * Handles pricing calculations and add-to-cart functionality
 * Supports: vanilla products, coffret products, tube products
 */

class MainProductForm extends HTMLElement {
  constructor() {
    super();
    this.productVariants = [];
    this.tubeVariants = [];
    this.selectedVanillaVariant = null;
    this.selectedTubeVariant = null;
    this.packagingType = 'packet';
    this.quantity = 1;
    this.isTubeProduct = false;
    this.selectedTubeProductVariantId = null;
    this.discount = 1;
    this.hasDiscount = false;
  }

  connectedCallback() {
    this.isTubeProduct = this.hasAttribute('data-tube-product');
    this.initializeData();
    this.cacheElements();
    this.bindEvents();
    this.initializeDefaults();
    this.updateTubePrice();
    this.updateTotalPrice();
  }

  initializeData() {
    const productJson = this.querySelector('[data-product-variants]');
    const tubeJson = this.querySelector('[data-tube-variants]');

    if (productJson) {
      try {
        this.productVariants = JSON.parse(productJson.textContent);
      } catch (e) {
        console.error('Failed to parse product variants:', e);
      }
    }

    if (tubeJson) {
      try {
        this.tubeVariants = JSON.parse(tubeJson.textContent);
      } catch (e) {
        console.error('Failed to parse tube variants:', e);
      }
    }
  }

  cacheElements() {
    this.vanillaSelect = this.querySelector('[data-vanilla-select]');
    this.packagingInputs = this.querySelectorAll('[data-packaging-input]');
    this.tubeInputs = this.querySelectorAll('[data-tube-input]');
    this.tubePriceDisplay = this.querySelector('[data-tube-price]');
    this.tubeComparePriceDisplay = this.querySelector('[data-tube-compare-price]');
    this.tubeOptionsContainer = this.querySelector('[data-tube-options]');

    // Tube product specific elements
    this.tubeQuantityButtons = this.querySelectorAll('[data-tube-qty-btn]');

    // Coffret specific elements
    this.coffretVariantInput = this.querySelector('[data-coffret-variant]');

    const cartSection = document.querySelector('main-product-cart');
    if (cartSection) {
      this.quantitySelect = cartSection.querySelector('[data-quantity-select]');
      this.totalPriceDisplay = cartSection.querySelector('[data-total-price]');
      this.totalComparePriceDisplay = cartSection.querySelector('[data-total-compare-price]');
      this.addToCartButton = cartSection.querySelector('[data-add-to-cart]');

      this.discount = parseFloat(cartSection.dataset.discount) || 1;
      this.hasDiscount = cartSection.dataset.hasDiscount === 'true';
    }
  }

  bindEvents() {
    if (this.vanillaSelect) {
      this.vanillaSelect.addEventListener('change', () => this.onVanillaChange());
    }

    this.packagingInputs.forEach(input => {
      input.addEventListener('change', () => this.onPackagingChange());
    });

    this.tubeInputs.forEach(input => {
      input.addEventListener('change', () => this.onTubeChange());
    });

    if (this.quantitySelect) {
      this.quantitySelect.addEventListener('change', () => this.onQuantityChange());
    }

    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', (e) => this.onAddToCart(e));
    }

    // Tube product quantity buttons
    this.tubeQuantityButtons.forEach(btn => {
      btn.addEventListener('click', () => this.onTubeQuantityButtonClick(btn));
    });
  }

  initializeDefaults() {
    if (this.isTubeProduct && this.tubeQuantityButtons.length > 0) {
      const activeBtn = this.querySelector('[data-tube-qty-btn].active');
      if (activeBtn) {
        this.selectedTubeProductVariantId = activeBtn.dataset.variantId;
      }
    }

    // Initialize packagingType based on currently checked radio
    const selectedPackaging = this.querySelector('[data-packaging-input]:checked');
    if (selectedPackaging) {
      this.packagingType = selectedPackaging.value;
    }
  }

  onVanillaChange() {
    this.updateTubePrice();
    this.updateTotalPrice();
  }

  onPackagingChange() {
    const selectedInput = this.querySelector('[data-packaging-input]:checked');
    this.packagingType = selectedInput ? selectedInput.value : 'packet';

    const tubeCheckbox = this.querySelector('[data-packaging="tube"]');
    if (tubeCheckbox) {
      if (this.packagingType === 'tube') {
        tubeCheckbox.classList.add('checkbox--active');
      } else {
        tubeCheckbox.classList.remove('checkbox--active');
      }
    }

    this.updateTubePrice();
    this.updateTotalPrice();
  }

  onTubeChange() {
    this.updateTubePrice();
    this.updateTotalPrice();
  }

  onQuantityChange() {
    this.quantity = parseInt(this.quantitySelect?.value || 1, 10);
    this.updateTotalPrice();
  }

  onTubeQuantityButtonClick(clickedBtn) {
    // Remove active class from all buttons
    this.tubeQuantityButtons.forEach(btn => btn.classList.remove('active'));

    // Add active class to clicked button
    clickedBtn.classList.add('active');

    // Update selected variant ID
    this.selectedTubeProductVariantId = clickedBtn.dataset.variantId;

    // Update price display
    this.updateTotalPrice();
  }

  updateTubePrice() {
    const selectedTubeInput = this.querySelector('[data-tube-input]:checked');
    if (!selectedTubeInput) return;

    const variantId = selectedTubeInput.value;
    const price = parseInt(selectedTubeInput.dataset.price, 10) || 0;

    // Get compare price from data attribute or fallback to tubeVariants JSON
    let comparePrice = parseInt(selectedTubeInput.dataset.comparePrice, 10) || 0;
    if (!comparePrice && this.tubeVariants.length > 0) {
      const variant = this.tubeVariants.find(v => v.id == variantId);
      comparePrice = variant?.compare_at_price || 0;
    }

    if (this.tubePriceDisplay) {
      this.tubePriceDisplay.textContent = this.formatMoney(price);
    }

    if (this.tubeComparePriceDisplay) {
      if (comparePrice > price) {
        this.tubeComparePriceDisplay.textContent = this.formatMoney(comparePrice);
        this.tubeComparePriceDisplay.classList.remove('hidden');
      } else {
        this.tubeComparePriceDisplay.classList.add('hidden');
      }
    }
  }

  getSelectedVanillaPrice() {
    // For tube products, get price from selected button
    if (this.isTubeProduct) {
      const activeBtn = this.querySelector('[data-tube-qty-btn].active');
      return parseInt(activeBtn?.dataset.price || 0, 10);
    }

    // For coffret, get first variant price
    if (this.coffretVariantInput) {
      const variantId = this.coffretVariantInput.value;
      const variant = this.productVariants.find(v => v.id == variantId);
      return variant ? variant.price : 0;
    }

    // For vanilla products
    if (!this.vanillaSelect) {
      const firstVariant = this.productVariants[0];
      return firstVariant ? firstVariant.price : 0;
    }

    const selectedOption = this.vanillaSelect.options[this.vanillaSelect.selectedIndex];
    return parseInt(selectedOption?.dataset.price || 0, 10);
  }

  getSelectedTubePrice() {
    if (this.packagingType !== 'tube') return 0;

    const selectedTubeInput = this.querySelector('[data-tube-input]:checked');
    return parseInt(selectedTubeInput?.dataset.price || 0, 10);
  }

  getSelectedVanillaComparePrice() {
    // For tube products, get compare price from selected button
    if (this.isTubeProduct) {
      const activeBtn = this.querySelector('[data-tube-qty-btn].active');
      const variantId = activeBtn?.dataset.variantId;
      const variant = this.productVariants.find(v => v.id == variantId);
      return variant?.compare_at_price || 0;
    }

    // For coffret, get first variant compare price
    if (this.coffretVariantInput) {
      const variantId = this.coffretVariantInput.value;
      const variant = this.productVariants.find(v => v.id == variantId);
      return variant?.compare_at_price || 0;
    }

    // For vanilla products
    if (this.vanillaSelect) {
      const selectedOption = this.vanillaSelect.options[this.vanillaSelect.selectedIndex];
      // First try data attribute
      const dataComparePrice = parseInt(selectedOption?.dataset.comparePrice, 10) || 0;
      if (dataComparePrice > 0) return dataComparePrice;

      // Fallback to productVariants JSON
      const variantId = this.vanillaSelect.value;
      const variant = this.productVariants.find(v => v.id == variantId);
      return variant?.compare_at_price || 0;
    }

    return this.productVariants[0]?.compare_at_price || 0;
  }

  getSelectedTubeComparePrice() {
    if (this.packagingType !== 'tube') return 0;

    const selectedTubeInput = this.querySelector('[data-tube-input]:checked');
    if (!selectedTubeInput) return 0;

    // First try data attribute
    const dataComparePrice = parseInt(selectedTubeInput.dataset.comparePrice || 0, 10);
    if (dataComparePrice > 0) return dataComparePrice;

    // Fallback to tubeVariants JSON
    const variantId = selectedTubeInput.value;
    const variant = this.tubeVariants.find(v => v.id == variantId);
    return variant?.compare_at_price || 0;
  }

  calculateTotalPrice() {
    let vanillaPrice = this.getSelectedVanillaPrice();
    const tubePrice = this.getSelectedTubePrice();

    // Apply discount if applicable
    if (this.hasDiscount) {
      vanillaPrice = Math.round(vanillaPrice * this.discount);
    }

    // For tube products, quantity is always 1 (quantity is in variant)
    if (this.isTubeProduct) {
      const cartQuantity = parseInt(this.quantitySelect?.value || 1, 10);
      return vanillaPrice * cartQuantity;
    }

    const quantity = parseInt(this.quantitySelect?.value || 1, 10);
    return (vanillaPrice + tubePrice) * quantity;
  }

  calculateTotalComparePrice() {
    const vanillaPrice = this.getSelectedVanillaPrice();
    const vanillaComparePrice = this.getSelectedVanillaComparePrice();
    const tubePrice = this.getSelectedTubePrice();
    const tubeComparePrice = this.getSelectedTubeComparePrice();

    // When discount is active, compare price is the original price (without discount)
    let effectiveVanillaCompare;
    if (this.hasDiscount) {
      effectiveVanillaCompare = vanillaPrice;
    } else {
      effectiveVanillaCompare = vanillaComparePrice > vanillaPrice ? vanillaComparePrice : vanillaPrice;
    }
    const effectiveTubeCompare = tubeComparePrice > tubePrice ? tubeComparePrice : tubePrice;

    // For tube products
    if (this.isTubeProduct) {
      const cartQuantity = parseInt(this.quantitySelect?.value || 1, 10);
      return effectiveVanillaCompare * cartQuantity;
    }

    const quantity = parseInt(this.quantitySelect?.value || 1, 10);
    return (effectiveVanillaCompare + effectiveTubeCompare) * quantity;
  }

  updateTotalPrice() {
    const total = this.calculateTotalPrice();
    const totalCompare = this.calculateTotalComparePrice();

    if (this.totalPriceDisplay) {
      this.totalPriceDisplay.textContent = this.formatMoney(total);
    }

    if (this.totalComparePriceDisplay) {
      if (totalCompare > total) {
        this.totalComparePriceDisplay.textContent = this.formatMoney(totalCompare);
        this.totalComparePriceDisplay.classList.remove('hidden');
      } else {
        this.totalComparePriceDisplay.classList.add('hidden');
      }
    }

    // Dispatch event for sticky bar sync
    this.dispatchPriceUpdate(total, totalCompare);
  }

  dispatchPriceUpdate(totalPrice, totalComparePrice) {
    const variantId = this.getSelectedVariantId();
    const tubeVariantId = this.getSelectedTubeVariantId();

    document.dispatchEvent(new CustomEvent('price:updated', {
      detail: {
        variantId: variantId,
        tubeVariantId: tubeVariantId,
        totalPrice: totalPrice,
        totalComparePrice: totalComparePrice,
        packagingType: this.packagingType
      }
    }));
  }

  formatMoney(cents) {
    // n°7 (maquette) : format français — virgule, espace insécable avant €
    const amount = (cents / 100).toFixed(2);
    return `${amount.replace('.', ',')} €`;
  }

  getSelectedVariantId() {
    // For tube products
    if (this.isTubeProduct) {
      return this.selectedTubeProductVariantId;
    }

    // For coffret products
    if (this.coffretVariantInput) {
      return this.coffretVariantInput.value;
    }

    // For vanilla products
    if (this.vanillaSelect) {
      return this.vanillaSelect.value;
    }

    return this.productVariants[0]?.id;
  }

  getSelectedTubeVariantId() {
    if (this.packagingType !== 'tube') return null;
    const selectedTubeInput = this.querySelector('[data-tube-input]:checked');
    return selectedTubeInput?.value || null;
  }

  async onAddToCart(e) {
    e.preventDefault();

    if (!this.addToCartButton) return;

    const textEl = this.addToCartButton.querySelector('.main-product-cart-add__text');
    const pricesEl = this.addToCartButton.querySelector('.main-product-cart-add__prices');
    const loadingEl = this.addToCartButton.querySelector('.main-product-cart-add__loading');

    this.addToCartButton.disabled = true;
    if (textEl) textEl.classList.add('hidden');
    if (pricesEl) pricesEl.classList.add('hidden');
    if (loadingEl) loadingEl.classList.remove('hidden');

    const items = [];
    const quantity = parseInt(this.quantitySelect?.value || 1, 10);

    const variantId = this.getSelectedVariantId();
    if (variantId) {
      items.push({
        id: variantId,
        quantity: quantity
      });
    }

    // Only add tube variant for vanilla products with tube packaging
    if (!this.isTubeProduct) {
      const tubeVariantId = this.getSelectedTubeVariantId();
      if (tubeVariantId) {
        items.push({
          id: tubeVariantId,
          quantity: quantity
        });
      }
    }

    try {
      const response = await fetch(gvUrl('/cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const result = await response.json();

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));

      const sideCart = document.querySelector('side-cart');
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');

      if (sideCart && typeof sideCart.open === 'function') {
        await sideCart.reloadSidecart();
        sideCart.open();
      } else if (cartDrawer && typeof cartDrawer.open === 'function') {
        const sectionsResponse = await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`);
        const sections = await sectionsResponse.json();
        cartDrawer.renderContents({ sections });
      } else if (cartNotification) {
        cartNotification.renderContents(result);
      } else {
        window.location.href = gvUrl('/cart');
      }

    } catch (error) {
      console.error('Add to cart error:', error);
      alert(gvTr('gv.w_main_product_form_js.erreur_ajout_html', 'Erreur lors de l\'ajout au panier. Veuillez réessayer.'));
    } finally {
      this.addToCartButton.disabled = false;
      if (textEl) textEl.classList.remove('hidden');
      if (pricesEl) pricesEl.classList.remove('hidden');
      if (loadingEl) loadingEl.classList.add('hidden');
    }
  }
}

if (!customElements.get('main-product-form')) {
  customElements.define('main-product-form', MainProductForm);
}
